export const INITIAL_SIZE = { width: 500, height: 400 };
export const MIN_SIZE = { width: 400, height: 200 };
export const MAX_SIZE = { width: 2000, height: 2000 };
